import Swiper from "swiper";
import { SwiperOptions } from "swiper/types/swiper-options";
import { Navigation, Pagination, Autoplay, Mousewheel, Scrollbar } from 'swiper/modules';

const fadeIn = () => {
    const lists = document.querySelectorAll(
        ".jobs-carousel .attrax-list-widget__list, .post-carousel .attrax-list-widget__list"
    );
    lists.forEach((list) => list.classList.add("show"));
};

const createNavigationButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-nav-btn-container");
    const navButtons = swiperInstance.el.querySelectorAll(
        ".swiper-button-prev, .swiper-button-next"
    );

    for (let btn of navButtons) {
        btn.remove();
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

const createViewAllButtonContainer = (swiperInstance: Swiper) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-view-all");
    const viewAllButton = swiperInstance.el.querySelectorAll(
        ".swiper-slide.attrax-button"
    );

    for (let btn of viewAllButton) {
        btn.remove();
        btn.classList.remove("swiper-slide");
        btn.setAttribute("style", "");
        btn.setAttribute("aria-label", "view all");
        wrapper.appendChild(btn);
    }

    swiperInstance.el.appendChild(wrapper);
};

const createCarousel = (el: string, opt: SwiperOptions) => {
    const elements = document.querySelectorAll(el);

    elements.forEach((element: HTMLElement) => {
        const children = [...element.children];

        element.classList.add("swiper");
        for (let child of children) {
            child.classList.add("swiper-slide");
        }

        const pagination = document.createElement("div");
        pagination.classList.add("swiper-pagination");
        element.appendChild(pagination);

        if (opt.scrollbar) {
            const scrollbar = document.createElement("div");
            scrollbar.classList.add("swiper-scrollbar");
            element.appendChild(scrollbar);
        }

        const swiper = new Swiper(element, {
            modules: [ Navigation, Pagination ],
            createElements: true,
            navigation: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            on: {
                afterInit: (swiper) => {
                    createNavigationButtonContainer(swiper);
                },
            },
            ...opt,
        });
    });
};

const createScrollingCtaCarousel = () => {
    createCarousel(".corp-scrolling-cta-banner", {
        modules: [ Autoplay ],
        grabCursor: true,
        effect: "fade",
        autoplay: {
            delay: 80000,
            disableOnInteraction: true,
        },
    });
};

const createListWidgetCarousel = () => {
    const swiper = createCarousel(".jobs-carousel .attrax-list-widget__list", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        navigation: true,
        spaceBetween: 28,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            630: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
        on: {
            afterInit: (swiper) => {
                createNavigationButtonContainer(swiper);
                createViewAllButtonContainer(swiper);
                fadeIn();
            },
        },
    });
};

const createPostsCarousel = () => {
    createCarousel(".post-carousel .attrax-list-widget__list", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        navigation: true,
        spaceBetween: 75,
        on: {
            afterInit: (swiper) => {
                createNavigationButtonContainer(swiper);
                createViewAllButtonContainer(swiper);
                fadeIn();
            },
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            630: {
                slidesPerView: 2,
            },
            990: {
                slidesPerView: 3,
            },
        },
    });
};

const createQuotesCarousel = () => {
    createCarousel(".corp-quotes-banner", {
        modules: [ Navigation, Pagination, Autoplay ],
        navigation: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    });
};

const createAwardsCarousel = () => {
    createCarousel(".corp-awards-banner", {
        modules: [ Navigation, Pagination ],
        slidesPerView: 1,
        navigation: true,
        spaceBetween: 10,
        loop: true,
        breakpoints: {
            479: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 3,
            },
            990: {
                slidesPerView: 4,
            },
        },
    });
};

const createQuotesCTACarousel = () => {
    createCarousel(".banner-quote-cta", {
        modules: [ Navigation, Pagination, Autoplay ],
        navigation: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 5000,
            disableOnInteraction: true,
        },
    });
};

const createTabSwitcherarousel = () => {
    createCarousel(".snippet-tab-switcher__carousel-button-container", {
        modules: [ Navigation, Scrollbar, Mousewheel ],
        navigation: true,
        direction: "vertical",
        mousewheel: {
            invert: true
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            hide: false,
            dragSize: 100
        },
        loop: false,
        watchOverflow: true,
        slidesPerView: "auto",
        on: {
            afterInit: (swiper) => {
                createNavigationButtonContainer(swiper);

                const scrollbar = swiper.scrollbar.el;
                const container = swiper.navigation.nextEl.parentElement;
                container?.appendChild(scrollbar);

                const prevBtn = swiper.navigation.prevEl;
                const nextBtn = swiper.navigation.nextEl;
                container?.insertBefore(prevBtn, nextBtn);
            },
        },
    });
};

export const CreateCarousels = () => {
    createAwardsCarousel();
    createListWidgetCarousel();
    createPostsCarousel();
    createQuotesCarousel();
    createScrollingCtaCarousel();
    createQuotesCTACarousel();
    createTabSwitcherarousel();
};
